var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-navigation'),_c('el-divider'),(_vm.$canAndRulesPass(_vm.user, 'user.see_home_charts'))?_c('home-charts'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }